export const ROUTES = {
    // BASIC
    HOME: '/',
    LOGIN: '/login',
    REGISTER: '/register',
    RECOVER_PWD: '/recoveryAccount',
    ERROR: '/error',
    VALIDATE: '/validateAccount',
    CONTACT: 'https://hubciberseguridad.tec.mx/es/contacto',
    POLICIES: 'https://tec.mx/es/avisos-de-privacidad',

    // USER
    RESERVE: '/reserve',
    DETAILS: '/details',
    FAVORITES: '/favorites',
    CALENDAR: '/calendar',
    RESERVATIONS: '/my-reservations',
    PROFILE: '/profile',
    HISTORY: '/history',

    // ADMIN
    ADMIN: '/admin',
    RESOURCES: '/resources',
    PANEL: '/panel',
    RESOURCE_BY_ID: '/resource',
    ADMIN_RESERVATIONS: '/reservations',
    STATISTICS: '/statistics',
    USERS: '/users',
}